import {Component} from '@angular/core';

@Component({
    selector: 'app-wizard-content',
    template: `
        <div class="wizard-content">
            <div class="wizard-content__aside">
                <div class="wizard-content__sticky">
                    <ng-content select="[sticky]"></ng-content>
                </div>
            </div>
            <div class="wizard-content__main">
                <ng-content></ng-content>
            </div>
        </div>
    `
})

export class WizardContentComponent {
}
